import { memo } from "react";

export const AdminFooter = memo(() => {
	return (
		<div className="border-t pr-4">
			<footer className='box-border h-[54px] min-h-[54px] max-h-[54px] items-center flex justify-between bg-card md:flex'>
				<div className='px-6 py-4 text-sm text-muted-foreground'>
					© 2023{" "}
					<a href='https://www.vlu.edu.vn/vi' target='_blank' className='text-red-500 hover:underline'>
						Trường Đại Học Văn Lang
					</a>
				</div>
				<div className='px-6 py-4 text-sm text-muted-foreground'>
					Phát triển bởi{" "}
					<a href='https://itconnect.vlu.edu.vn/' target='_blank' className='text-red-500 hover:underline'>
						Phòng Công Nghệ Thông Tin
					</a>
				</div>
			</footer>
		</div>
	);
});
